import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Tooltip } from 'antd';

import { makeSelectAllQuestionsForCarryForward } from 'containers/QuestionnairePage/selectors';
import { replaceMentionedPromptsWithBlank } from 'components/FormattedInput/helpers';
import Pficon from 'components/Pficon';

const DEFAULT_BEFORE_INDEX_STYLE = {
  width: 20,
  minHeight: 16,
  right: '100%',
  top: -1,
};

const DEFAULT_AFTER_INDEX_STYLE = {
  width: 16,
  minHeight: 16,
  marginLeft: 4,
};

const CarryForwardTooltip = ({
  questionRefId,
  className,
  spanStyle,
  variant = 'before-index',
}) => {
  const isAfterIndex = variant === 'after-index';
  const resolvedClassName =
    className ??
    (isAfterIndex
      ? 'color-grey-10 display-inline-block vertical-align-middle'
      : 'position-absolute color-grey-10');
  const resolvedSpanStyle =
    spanStyle ??
    (isAfterIndex ? DEFAULT_AFTER_INDEX_STYLE : DEFAULT_BEFORE_INDEX_STYLE);
  const questionsForCarryForward = useSelector(
    makeSelectAllQuestionsForCarryForward,
  );

  const relevantQuestion = useMemo(
    () => questionsForCarryForward.find(({ refId }) => refId === questionRefId),
    [questionsForCarryForward, questionRefId],
  );

  const { prompt = '', label } = relevantQuestion || {};
  const indexedTitle = `${label} ${replaceMentionedPromptsWithBlank(prompt)}`;
  const emptyTooltip = !prompt && !label;
  return (
    <Tooltip
      title={
        <span>
          Comes from <strong>{indexedTitle}</strong>
        </span>
      }
      trigger={emptyTooltip ? [] : ['hover']}
      placement="topLeft"
      overlayClassName="tooltip-light ant-tooltip-no-arrow"
      overlayStyle={{ maxWidth: 500 }}
    >
      <span className={resolvedClassName} style={resolvedSpanStyle}>
        <Pficon type="carry-forward-arrow" />
      </span>
    </Tooltip>
  );
};

CarryForwardTooltip.propTypes = {
  questionRefId: PropTypes.string,
  className: PropTypes.string,
  spanStyle: PropTypes.object,
  variant: PropTypes.oneOf(['before-index', 'after-index']),
};

export default CarryForwardTooltip;
